// extracted by mini-css-extract-plugin
module.exports = {"select":"Documents_select__2gTGo"};